import styled, { css } from 'styled-components';
import { mediasQuery } from '@utils/responsive';

export const List = styled.ul`
  ${({ theme }) => css`
    ${mediasQuery.maxMdMax} {
      margin-right: ${theme.spacing.km3};
    }
  `}
`;

export const InfoBottom = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.km1};
  `}
`;

export const Span = styled.span`
  ${({ theme }) => css`
    color: ${theme.color.text.neutral.default};
    font-weight: ${theme.font.weight.medium};
    font-size: ${theme.font.size.m3};
  `}
`;

export const Information = styled(Span)`
  ${({ theme }) => css`
    font-size: ${theme.font.size.m1};
    font-weight: ${theme.font.weight.bold};
    text-transform: uppercase;

    ${mediasQuery.maxMdMax} {
      position: absolute;
      right: calc(${theme.spacing.km1} / 2);
    }
  `}
`;

export const Prefix = styled(Span)`
  ${({ theme }) => css`
    font-weight: ${theme.font.weight.bold};
    color: ${theme.color.text.neutral.weak};
    font-size: ${theme.font.size.m1};

    ${mediasQuery.maxMdMax} {
      display: flex;
    }
  `}
`;

export const Description = styled(Span)`
  ${({ theme }) => css`
    font-weight: ${theme.font.weight.bold};
  `}
`;

export const Strong = styled(Span)`
  ${({ theme }) => css`
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.m3};
    color: ${theme.color.text.neutral.strong};
  `}
`;

export const InfoLeft = styled.div`
  ${({ theme }) => css`
    margin-left: ${theme.spacing.km4};

    ${mediasQuery.maxMdMax} {
      margin-left: ${theme.spacing.km3};
    }
  `}
`;

export const WrapperInfo = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    gap: ${theme.spacing.km8};

    ${mediasQuery.maxMdMax} {
      gap: ${theme.spacing.km2};
    }
  `}
`;
